import { useQuery } from '@apollo/react-hooks';
import FileLink from 'components/FileLink';
import { Loading } from 'modules';
import { FileListQuery } from 'queries/File/File';
import React from 'react';
import SendReportToEmail from './SendReportToEmail';

interface ContractFilesProps {
  form: GQL.IContractOnlineForm;
  contract: GQL.IContract;
}

const ContractFiles = ({ form, contract }: ContractFilesProps) => {
  const filesQuery = useQuery(FileListQuery, {
    variables: {
      where: {
        id_files: contract?.id_files,
      },
    },
  });

  const { data, loading } = filesQuery;

  if (loading) {
    return <Loading />;
  }

  const files = data?.fileList;

  const folderReport = files?.find((file: GQL.IFile) => {
    return file.internal_code === '2_A_VYHOTOVENY_POSUDOK';
  });

  const isRoot = (file: GQL.IFile): boolean => {
    return file.id_parent === folderReport?.id;
  };

  const sort = (a: GQL.IFile, b: GQL.IFile) => {
    return a.filename > b.filename ? 1 : 0;
  };

  const finallyFilesList = files?.filter(isRoot).sort(sort);

  return (
    <div>
      {finallyFilesList.map((file: GQL.IFile) => {
        return (
          <div key={file.id}>
            <FileLink file={file} />
          </div>
        );
      })}
      {finallyFilesList?.length === 0 ? <i>Nie sú k dispozícii žiadne súbory</i> : <SendReportToEmail form={form} />}
    </div>
  );
};

export default ContractFiles;
